import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  formContainer: {
    marginTop: theme.spacing(3),
  },
  stepperContainer: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '-ms-overflow-style': 'none',
      'scrollbar-width': 'none',
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 0),
      minWidth: '800px',
    },
  },
  step: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
      flexShrink: 0,
    },
  },
  contentSplitter: {
    marginTop: theme.spacing(1),
  },
  downContainer: {
    padding: theme.spacing(1, 0),
  },
  stepTitle: {
    fontWeight: 'bold',
    fontSize: '1.25rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  divider: {
    marginBottom: theme.spacing(3),
  },
  buttons: {
    marginTop: theme.spacing(4),
  },
  quesitosContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
  },
}))

export default useStyles
